<template>
  <div class="contain">
    <div class="user-info">
      <div>
        {{ user?.name }} &nbsp;&nbsp; &nbsp;&nbsp;{{ user?.sex || '---' }}
      </div>
      <div @click="onChangeUser">切换/新建检查人<van-icon name="arrow" size="15px" /></div>
    </div>
    <div class="analysis-main" ref="main" :style="mainStyle">
      <div>6~15岁孩子理论正常屈光度、眼轴示意图</div>
      <echart-line ref="chart" />
      <echart-line ref="chart2" />
    </div>
    <div class="tip">标准数据引自：中华预防医学会公共卫生眼科分
      会. 中国学龄儿童眼球远视储备、眼轴长度、角
      膜曲率参考区间及相关遗传因素专家共识
      （2022 年）[J]. 中华眼科杂志, 2022, 58(2):
      96-102. DOI: 10.3760/cma.j. cn112142-
      20210603-00267</div>
    <div class="bottom" v-if="openChat || openShop">
      <div class="nav" v-if="openChat" @click="onGoDoctorGroup">
        <div class="icon">
          <i class="iconfont iconertongshengchangquxian" style="color: #1296db;font-size: 1rem;"></i>
        </div>
        <div>专家咨询</div>
      </div>
      <div class="nav" v-if="openShop" @click="onGoShopGroup">
        <div class="icon">
          <img src="../../assets/img/account.png">
        </div>
        <div>护眼商城</div>
      </div>
    </div>

    <div class="back" @click="goAIRboot">
      <van-icon name="arrow-left" size="18" />
      <div>返回</div>
    </div>
  </div>
</template>
<script>
import echartLine from './components/echartLine.vue';
import { formatList, lineAgeList } from './js/detail';

export default {
  name: 'uniapp-analysis',
  components: { echartLine },
  data() {
    return {
      openId: '',
      hospitalId: '',
      onType: 0,
      showLeftAxialLength:'',
      showRightAxialLength: '',
      showLeftDiopterRecord: '',
      showRightDiopterRecord: '',
      leftAvgDiopterRecord:'',
      rightAvgDiopterRecord: '',
      leftSeList: '',
      rightSeList: '',
      leftAxialLengthList:'',
      rightAxialLengthList:'',
      leftAvgAxialLength: '',
      rightAvgAxialLength: '',
      rightSe: [],
      leftSe: [],
      rightZhou: [],
      leftZhou: [],
      showTip: false,
      height: 'height:600px;',
      sid: '',
      mainStyle: '',
      openChat: 0,
      openShop: 0,
      chartData: {
        id: 'chat',
        yData: [
          [[6,3.5], [7,3.38],[8,3.2], [9,3],[10,2.75], [11,2.45], [12,2.15],[13,1.8], [14,1.45], [15,1.05]],
          [[6, 2.5], [7, 2.3], [8, 2.1], [9, 1.9], [10, 1.7], [11, 1.5], [12, 1.3], [13, 1.15], [14, 1], [15, 0.9]],
          [[6, 1.9], [7, 1.65], [8, 1.45], [9, 1.3], [10, 1.15], [11, 1.05], [12, 0.95], [13, 0.85], [14, 0.75], [15, 0.7]],

          [[6, 1.45], [7, 1.25], [8, 1.05], [9, 0.9], [10, 0.75], [11, 0.65], [12, 0.55], [13, 0.45], [14, 0.35], [15, 0.3]],

          [[6, 1.15], [7, 0.95], [8, 0.75], [9, 0.55], [10, 0.4], [11, 0.25], [12, 0.15], [13, 0.05], [14, 0], [15, -0.05]],

          [[6, 0.95], [7, 0.7], [8, 0.5], [9, 0.3], [10, 0.15], [11, 0], [12, -0.1], [13, -0.2], [14, -0.25], [15, -0.3]],

          [[6, 0.5], [7, 0.35], [8, 0.2], [9, 0.05], [10, -0.1], [11, -0.2], [12,-0.3], [13, -0.35], [14, -0.4], [15, -0.45]],
        ], 
        yNames: ['p97', 'p90', 'p75', 'p50', 'p25', 'p10', 'p3'],
        //yTotal:[[15, 1.05],[15, 0.9],[15, 0.7],[15, 0.3],[15, -0.05],[15, -0.45]],
        colors: ['#ddd','#ddd','#ddd','#f33','#ddd','#ddd','#ddd'],
        xMin: 4,
        xMax: 17,
        pointType: 1,
        padding: [260, 0, 0, 80],
        yMin: -1,
        yTop: '4.5%',
        yMax: 4,
        yName: '屈光度 | 等效球镜(D)',
        interval: 1
      },
      chartData2: {
        id: 'chat2',
        yData: [
          [[6, 23.8], [7, 24], [8, 24.2], [9, 24.35], [10, 24.5], [11, 24.6], [12, 24.7], [13, 24.75], [14, 24.8], [15, 24.85]],

          [[6, 23.25], [7, 23.5], [8, 23.7], [9, 23.85], [10, 24], [11, 24.1], [12, 24.2], [13, 24.25], [14, 24.3], [15, 24.31]],

          [[6, 22.95], [7, 23.15], [8, 23.35], [9, 23.55], [10, 23.7], [11, 23.8], [12, 23.85], [13, 23.9], [14, 23.92], [15, 23.94]],

          [[6, 22.45], [7, 22.6], [8, 22.8], [9, 23], [10, 23.15], [11, 23.25], [12, 23.35], [13, 23.38], [14, 23.4], [15, 23.42]],

          [[6, 21.8], [7, 22.05], [8, 22.3], [9, 22.5], [10, 22.7], [11, 22.8], [12, 22.85], [13, 22.88], [14, 22.9], [15, 22.92]],

          [[6, 21.5], [7, 21.7], [8, 21.9], [9, 22.05], [10, 22.2], [11, 22.3], [12, 22.4], [13, 22.5], [14, 22.6], [15, 22.65]],

          [[6, 20.9], [7, 21.05], [8, 21.2], [9, 21.35], [10, 21.5], [11, 21.65], [12, 21.8], [13, 21.95], [14, 22.1], [15, 22.25]],
        ], 
        colors: ['#ddd', '#ddd', '#ddd', '#f33', '#ddd', '#ddd', '#ddd'],
        xMin: 4,
        pointType: 2,
        height: 'height:350px;',
        yTop: '7%',
        yNames: ['p97', 'p90', 'p75', 'p50', 'p25', 'p10', 'p3'],
        padding: [80, 0, 0, 80],
        xMax: 17,
        yMin: 20.5,
        yMax: 28,
        yName: '眼轴长度(mm)',
        interval: 0.5
      },
      user: {},
    }
  },
  mounted() {
    this.openId = this.$route.query.openId || '';
    this.hospitalId = this.$route.query.hospitalId || '';
    this.onType = this.$route.query.onType || 0;
    // this.sid = this.$route.query.sid || '';
    // 初始进入页面
     const record_select = localStorage.getItem('record_select'); // 一种默认记录
    if (record_select) {
      this.user = JSON.parse(record_select); 
      // 查曲线
      this.initLine();
    } else {
      this.onGetUserList();
    }

    
  },
  methods: {
    initLine() {
      const _this = this;
      setTimeout(async () => {
        await _this.onGetLine();
        _this.$refs.chart.onInit(_this.chartData, _this.showLeftDiopterRecord,
          _this.showRightDiopterRecord);
        _this.$refs.chart2.onInit(_this.chartData2, _this.showLeftAxialLength,
          _this.showRightAxialLength);
        _this.showTip = true;
        // _this.mainStyle = 'height:' + (_this.$refs.main.offsetHeight + 400) + 'px'+';';
      }, 100);
    },
    onGoDoctorGroup() { 
      this.$router.push(`/uniapp/doctorGroup?openId=${this.openId}&hospitalId=${this.hospitalId}`);
    },
    onGoShopGroup(){
      window.location.href="https://shop.yjkok.com/uniwebretail/#/"
    },
    goAIRboot() {
      const currentDomain = window.location.origin;
      if (this.onType && this.onType == 1){
        location.href = currentDomain + '/mini/#/?openId=' + this.openId + '&hospitalId=' + this.hospitalId
      }else {
        location.href = currentDomain + '/hospital-vue/#/salerobot?openId=' + this.openId + '&hospitalId=' + this.hospitalId
      }
    },
    async onGetLine() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.checkLine, {
        studentId: this.user.uid,
        ctrlType: 0,
        auth: auth.code,
        time: auth.time,
      });
      
      
      if (result.message === "Error: Miss auth parameter.") {
        setTimeout(() => {
          this.onGetLine();
        }, 500);
      } else {
        if (result.code === -1) {
          console.log('uid不存在');
          return;
        }
        if (result.data){
          this.openChat =  result.data.openChat
          this.openShop =  result.data.openShop
        }
        /** 屈光数据对象 */
        const returnDiopterRecordMap = result.data?.returnDiopterRecordMap;
        if (returnDiopterRecordMap != null) {
          this.leftAvgDiopterRecord =
            returnDiopterRecordMap.leftAvgDiopterRecord;
          this.rightAvgDiopterRecord =
            returnDiopterRecordMap.rightAvgDiopterRecord;
          this.leftSeList = returnDiopterRecordMap.seList.leftSeList;
          this.rightSeList = returnDiopterRecordMap.seList.rightSeList;
          this.leftSeList.arr = new Array();
          this.rightSeList.arr = new Array();
          this.rightSeList.arr[0] = this.rightAvgDiopterRecord;
          this.leftSeList.arr[0] = this.leftAvgDiopterRecord;
          this.showLeftDiopterRecord = returnDiopterRecordMap.showLeftDiopterRecord;
          this.showRightDiopterRecord = returnDiopterRecordMap.showRightDiopterRecord;
          this.onFormatList(this.rightSeList, lineAgeList, 3);
          this.onFormatList(this.leftSeList, lineAgeList, 4);
          this.chartData.rightData = this.rightSe;
          this.chartData.leftData = this.leftSe;
        }

        /** 眼轴数据对象 */
        const returnAxialLengthMap = result.data?.returnAxialLengthMap;
        this.leftAxialLengthList =
          returnAxialLengthMap.axialLengthList.leftAxialLengthList;
        this.rightAxialLengthList =
          returnAxialLengthMap.axialLengthList.rightAxialLengthList;
        this.leftAvgAxialLength = returnAxialLengthMap.leftAvgAxialLength;
        this.rightAvgAxialLength =
          returnAxialLengthMap.rightAvgAxialLength;
        this.rightAxialLengthList.arr = new Array();
        this.leftAxialLengthList.arr = new Array();
        this.leftAxialLengthList.arr[0] = this.leftAvgAxialLength;
        this.rightAxialLengthList.arr[0] = this.rightAvgAxialLength;
        this.showLeftAxialLength = returnAxialLengthMap.showLeftAxialLength;
        this.showRightAxialLength = returnAxialLengthMap.showRightAxialLength;
        debugger
        this.onFormatList(this.rightAxialLengthList, lineAgeList, 7);
        this.onFormatList(this.leftAxialLengthList, lineAgeList, 8);
        this.chartData2.rightData = this.rightZhou;
        this.chartData2.leftData =this.leftZhou;
      }

    },
    // 选择人员跳转
    onChangeUser() {
      this.$router.push(`/uniapp/user?openId=${this.openId}&hospitalId=${this.hospitalId}&pageType=2`);
    },
    // 获取人员列表
    async onGetUserList() {
      const auth = this.$createAuth(this.$md5);
      const _this = this;
      if (!this.openId) {
        this.showLoading = 0;
        return;
      }
      const result = await this.$http.get(this.$url.relatedStudents, {
        openId: this.openId,
        hospitalId: this.hospitalId,
        page: 1,
        pageSize: 30,
        auth: auth.code,
        time: auth.time
      });
      if (result.message === 'Error: Miss auth parameter.') {
        setTimeout(()=> {
          _this.showLoading = false;
          _this.isLoad = false;
          _this.onGetUserList();
        }, 500);
      } else {

        this.showLoading = 0;
        let list = result.data.studentList.list;
        this.user = list[0];

        // 查曲线
        this.initLine();
      }
    },
    onFormatList(list, agelist, type) {
      const { arr, arr1, arrStandard } = formatList(list, agelist, type);
      if (type == 3) {
        this.rightSeList.arr[1] = arr;
        this.rightSeList.arrStandard = arrStandard;
        const tempObj = {};
        this.rightSeList.forEach(item => {
          // this.rightSe.push([item.age, item.rightBallSe]);
          tempObj[item.age] = [item.age, item.rightBallSe];
        })
        this.rightSe = Object.values(tempObj);
      }
      if (type == 4) {
        this.leftSeList.arr[1] = arr;
        this.leftSeList.arrStandard = arrStandard;
        const tempObj = {};
        this.leftSeList.forEach(item => {
          tempObj[item.age] = [item.age, item.leftBallSe];
          // this.leftSe.push([item.age, item.leftBallSe]);
        })
        this.leftSe = Object.values(tempObj);
      }
      if (type == 7) {
        this.rightAxialLengthList.arr[1] = arr;
        this.rightAxialLengthList.arr[2] = arr1;
        this.rightAxialLengthList.arrStandard = arrStandard;
        const tempObj = {};
        this.rightAxialLengthList.forEach(item => {
          // this.rightZhou.push([item.age, item.rightAxialLength]);
          if (item.rightAxialLength && item.rightAxialLength != null && item.rightAxialLength != '') {
            tempObj[item.age] = [item.age, item.rightAxialLength];
          }
        })
        this.rightZhou = Object.values(tempObj);
      }
      if (type == 8) {
        this.leftAxialLengthList.arr[1] = arr;
        this.leftAxialLengthList.arr[2] = arr1;
        this.leftAxialLengthList.arrStandard = arrStandard;
        const tempObj = {};
        this.leftAxialLengthList.forEach(item => {
          // this.leftZhou.push([item.age, item.leftAxialLength]);
          if (item.leftAxialLength && item.leftAxialLength != null && item.leftAxialLength != '') {
              tempObj[item.age] = [item.age, item.leftAxialLength];
          }
          
        })
        this.leftZhou = Object.values(tempObj);
      }
    },
  }
}
</script>
<style lang="less" scoped>
.contain {
  width: 100vw;
  padding-bottom: 1.5rem;
  background: #f4f4f4;
}
.user-info {
  display: flex;
  justify-content: space-between;
  width: 6.9rem;
  padding: 0.3rem;
  font-size: 0.34rem;
  background: #fff;
}
.analysis-main {
  // margin-bottom: 1rem;
  padding: 0.3rem;
  background: #fff;
  .echart-box {
    width: 100%;
    height: 6700px;
  }
}
.tip {
  width: 6.5rem;
  margin: 0 auto;
  text-align: left;
  line-height: 1.5em;
  padding: 30px 0;
}
.bottom {
  position: fixed;
  bottom: 0;
  display: flex;
  width: 7.5rem;
  height: 1.6rem;
  background: #fff;
  border-radius: 0.05rem;
}
.nav {
  display: flex;
  width: 3.15rem;
  padding: 0.3rem;
  border-right: 0.01rem solid #eee;
  div {
    line-height: 1rem;
  }
  .icon {
    height: 1rem;
    margin-right: 0.3rem;
    img {
      width: 1rem;
      margin-top: 0.03rem;
    }
  }
}
.back {
    position: fixed;
    right: 20px;
    top: 50%;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #f0f0f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #000;
    font-size: 13px;
}
</style>